import { Action } from "@ngrx/store";
import { IAzureAuthentication } from "../interfaces/iazureauthentication";

export const actionTypes: any = {
    SET_TOKEN: "Setting user token",
    SELECT_TOKEN: "Selecting user token",
    SET_TOKEN_EXPIRED: "Set user token to expired",
    RESET_TOKEN_EXPIRED: "Resets token expired",
    SET_LOGGED_OUT: "User logged out",
    UNAUTHORIZED_ACCESS_ATTEMPT: "User unauthorized",
    RESET_UNAUTHORIZED_ACCESS_ATTEMPT: "Reset unauthorized access attempt",
    NOT_FOUND: "Resource not found"
};

export class SetTokenAction implements Action {
    type = actionTypes.SET_TOKEN;

    constructor(public payload: IAzureAuthentication) { }
}

export class SelectTokenAction implements Action {
    type = actionTypes.SELECT_TOKEN;
}

export class NotFoundAction implements Action {
    type = actionTypes.NOT_FOUND;
}

export class SetTokenExpiredAction implements Action {
    type = actionTypes.SET_TOKEN_EXPIRED;
}

export class ResetTokenExpiredAction implements Action {
    type = actionTypes.RESET_TOKEN_EXPIRED;
}

export class LoggedOutAction implements Action {
    type = actionTypes.SET_LOGGED_OUT;
    constructor(public payload: boolean) { }
}

export class UnauthorizedAction implements Action {
    type = actionTypes.UNAUTHORIZED_ACCESS_ATTEMPT;
}

export class ResetUnauthorizedAction implements Action {
    type = actionTypes.RESET_UNAUTHORIZED_ACCESS_ATTEMPT;
}

export type Actions = SetTokenAction
    | SelectTokenAction
    | SetTokenExpiredAction
    | LoggedOutAction
    | UnauthorizedAction
    | ResetUnauthorizedAction;